import FormField from 'components/Control/FormField'
import {React, styled} from 'common'
import {Accordion, AccordionDetails, AccordionSummary, Grid, IconButton} from '@mui/material'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {useMemo} from 'react'
import useResponsive from 'logic/useResponsive'
import {useTranslation} from 'react-i18next'

const FromArrayElement = ({
    arrayName,
    index,
    fields,
    append,
    remove,
    isAddButton,
    withButtons,
    ...p
}) => {
    const {t} = useTranslation()
    const {mediumScreen} = useResponsive()
    const formFields = useMemo(
        () => (
            <Grid container spacing={2}>
                {Object.values(fields).map((field, key) => (
                    <Grid key={`form_grid_container_${key}`} item xs={field?.xs} sm={field?.sm}>
                        <FormField
                            key={`form_field_${field?.name}`}
                            field={field}
                            i18n={arrayName}
                            index={index}
                            arrayName={arrayName}
                            {...p}
                        />
                    </Grid>
                ))}
            </Grid>
        ),

        [fields, arrayName, index, p]
    )
    return (
        <Container>
            <ContainerFields>
                {mediumScreen ? (
                    <Accordion sx={{width: 1}}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header">
                            {`${t(`${arrayName}.title`)} ${index + 1}`}
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            {formFields}
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    formFields
                )}
            </ContainerFields>
            {withButtons && (
                <>
                    <IconButton
                        onClick={append}
                        sx={{
                            width: '32px',
                            height: '32px',
                            visibility: !isAddButton ? 'hidden' : undefined,
                        }}>
                        <AddRoundedIcon sx={{width: '16px', height: '16px'}} />
                    </IconButton>

                    <IconButton onClick={() => remove(index)} sx={{width: '32px', height: '32px'}}>
                        <RemoveCircleOutlineRoundedIcon sx={{width: '16px', height: '16px'}} />
                    </IconButton>
                </>
            )}
        </Container>
    )
}

export default FromArrayElement

const Container = styled.div`
    display: flex;
    align-items: center;
`
const ContainerFields = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
`
